import { render, staticRenderFns } from "./WsInfoBelongsTo.vue?vue&type=template&id=6993e712&"
import script from "./WsInfoBelongsTo.vue?vue&type=script&lang=js&"
export * from "./WsInfoBelongsTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports